export default __webpack_public_path__ + "static/media/gymio.fd64c59d.jpg";